<div class="ai-hub-form pl-3 mt-3">
    <div class="d-flex justify-content-between">
        <div [routerLink]="''" class="cursor-pointer">
            <img src="./assets/img/asset-logo.svg" class="asset-logo" />
            <h4 class="d-inline-block">EstiMate</h4>
        </div>
        <div>
            <a class="cursor-pointer input-element" (click)="prefillSampleData()" href="javascript:void(0)">
                <img src="./assets/img/prefill.svg" alt="Prefill data" />
                Prefill sample data
            </a>
        </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="showForm">
        <div *ngFor="let control of formJson">
            <!-- Text -->
            <div *ngIf="control.type === 'text'" class="input-element">
                <label>{{ control.label }}</label>
                <input type="text" formControlName="{{ control.name }}" class="w-100">
            </div>

            <!-- Dropdown -->
            <div *ngIf="control.type === 'dropdown'" class="input-element">
                <label>{{ control.label }}</label>
                <mat-form-field class="w-100">
                    <mat-label>Select...</mat-label>
                    <mat-select formControlName="{{ control.name }}">
                        <mat-option *ngFor="let option of control.options" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Audio -->
            <div *ngIf="control.type === 'audio'" class="input-element">
                <label>{{ control.label }}</label>
                <app-audio></app-audio>
            </div>

            <!-- Toggle -->
            <div *ngIf="control.type === 'toggle'" class="input-element">
                <div class="slider">

                    <mat-slide-toggle formControlName="{{ control.name }}">Enable Auto Pilot Mode
                    </mat-slide-toggle>
                    <p class="description">Let AI categorize your request and help estimate project length
                    </p>
                </div>
            </div>

            <!-- Textarea -->
            <div *ngIf="control.type === 'textarea'" class="input-element">
                <label>{{ control.label }}</label>
                <p class="description">Press 'Tab' button to use the sample</p>
                <textarea formControlName="{{ control.name }}" rows="3" class="w-100" placeholder="{{placeholder}}"
                    tabindex="0" (keydown)="onKeydown($event, control.name)"></textarea>
            </div>
        </div>

        <button class="btn btn-primary input-element button-bottom w-100" type="submit">
            Estimate
        </button>
    </form>
</div>